"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabTokens = void 0;
const Global_1 = require("../../DesignSystem/tokens/Global");
const Spacing_1 = require("../../DesignSystem/tokens/global/Spacing");
const DesignToken_1 = __importDefault(require("../../DesignSystem/types/DesignToken"));
const tabPaddingTop = new DesignToken_1.default({
    name: 'tab-paddingTop',
    parent: [Global_1.globalTokens.spacingSM, Global_1.globalTokens.oldTokens.sizeSpaceM]
});
const tabPaddingRight = new DesignToken_1.default({
    name: 'tab-paddingRight',
    parent: [Global_1.globalTokens.spacingM, Global_1.globalTokens.oldTokens.sizeSpaceL]
});
const tabPaddingBottom = new DesignToken_1.default({
    name: 'tab-paddingBottom',
    parent: [Global_1.globalTokens.spacingSM, Global_1.globalTokens.oldTokens.sizeSpaceM]
});
const tabPaddingLeft = new DesignToken_1.default({
    name: 'tab-paddingLeft',
    parent: [Global_1.globalTokens.spacingM, Global_1.globalTokens.oldTokens.sizeSpaceM]
});
const tabBackgroundColor = new DesignToken_1.default({
    name: 'tab-backgroundColor',
    parent: [
        Global_1.globalTokens.colorBackgroundDefaultSecondary,
        Global_1.globalTokens.oldTokens.colorBackgroundBlank
    ]
});
const tabHoverBackgroundColor = new DesignToken_1.default({
    name: 'tab-hover-backgroundColor',
    parent: Global_1.globalTokens.oldTokens.colorHighlightLight
});
const tabActiveBorderLeftWidth = new DesignToken_1.default({
    name: 'tab-active-borderLeftWidth',
    parent: Global_1.globalTokens.oldTokens.sizeSpaceXS
});
const tabActiveBorderLeftColor = new DesignToken_1.default({
    name: 'tab-active-borderLeftColor',
    parent: Global_1.globalTokens.oldTokens.colorAccent
});
const tabActiveBackgroundColor = new DesignToken_1.default({
    name: 'tab-active-backgroundColor',
    parent: Global_1.globalTokens.oldTokens.colorHighlightDark
});
const tabActiveHoverBackgroundColor = new DesignToken_1.default({
    name: 'tab-active-hover-backgroundColor',
    parent: Global_1.globalTokens.oldTokens.colorHighlightDark
});
const tabDisabledBackgroundColor = new DesignToken_1.default({
    name: 'tab-disabled-backgroundColor',
    parent: Global_1.globalTokens.oldTokens.colorBackgroundNeutralLight
});
const tabColor = new DesignToken_1.default({
    name: 'tab-color',
    parent: [Global_1.globalTokens.colorForegroundDefaultPrimary, Global_1.globalTokens.oldTokens.colorTextMain]
});
const tabDisabledColor = new DesignToken_1.default({
    name: 'tab-disabled-color',
    parent: Global_1.globalTokens.colorForegroundDefaultDisabled
});
const tabHoverColor = new DesignToken_1.default({
    name: 'tab-hover-color',
    parent: Global_1.globalTokens.colorForegroundBrandHover
});
const tabTriangleBorderColor = new DesignToken_1.default({
    name: 'tab-triangle-borderColor',
    parent: Global_1.globalTokens.oldTokens.colorBorderMain
});
const tabTriangleBackgroundColor = new DesignToken_1.default({
    name: 'tab-triangle-borderColor',
    parent: Global_1.globalTokens.oldTokens.colorBackgroundBlank
});
const tabIconGap = new DesignToken_1.default({
    name: 'tab-icon-gap',
    parent: Spacing_1.spacingTokens.spacingS
});
exports.tabTokens = {
    tabPaddingTop,
    tabPaddingRight,
    tabPaddingBottom,
    tabPaddingLeft,
    tabBackgroundColor,
    tabHoverBackgroundColor,
    tabActiveBorderLeftWidth,
    tabActiveBorderLeftColor,
    tabActiveBackgroundColor,
    tabActiveHoverBackgroundColor,
    tabDisabledBackgroundColor,
    tabColor,
    tabHoverColor,
    tabDisabledColor,
    tabTriangleBorderColor,
    tabTriangleBackgroundColor,
    tabIconGap
};
//# sourceMappingURL=Tab.js.map